namespace SPA
{
	export namespace BWS
	{
		export namespace data
		{

			export class BWSHistorieTableDataModel
				extends ui.table.model.AbstractTableModel<Wollmilch.BWS.IBWS>
			{

				public constructor( descriptor?: ui.table.model.ITableModelDescriptor )
				{
					super( descriptor );

					this.ModelReader( new BWSHistorieTableDataReader() );
				}

				public buildHeader(): JQuery<HTMLElement>
				{
					return new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BWS.TABLE.historieKeyDate' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BWS.TABLE.historieTyp' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BWS.TABLE.historieRealValue' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BWS.TABLE.historieEarningrate' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BWS.TABLE.historieReferencevalue' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'BWS.TABLE.historieAction' ) ) )
					.Root();
				}

			}

		}
	}
}
